import { ReactNode } from 'react'
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import { FONTS } from 'src/constants'

interface ITopItemsStatisticWrapper {
  title: string
  children: ReactNode
}

const TopItemsStatisticListWrapper = ({ title, children }: ITopItemsStatisticWrapper) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop'))

  return (
    <Grid container maxWidth={436}>
      {isDesktop && (
        <Grid item xs={12} mb={'1.875rem'}>
          <Typography
            textAlign={'left'}
            fontSize={FONTS.SIZES.xxl}
            fontWeight={FONTS.WEIGHTS.bold}
            color={theme.palette.custom.darkBlue2}
          >
            {title}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={'10px'}>
          {children}
        </Box>
      </Grid>
    </Grid>
  )
}

export { TopItemsStatisticListWrapper }
